<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/wo/bad/quantity/record/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.productionNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--							:ids.sync="yt.conditions.equipmentIds">-->
            <!--						</yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds">-->
            <!--						</yi_cross_select>-->
          </el-form-item>

          <el-form-item :label="$t('bulushijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('bulucaozuoren')">
            <el-input v-model="yt.conditions.operator"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ createTimeStart: begin(), createTimeEnd: end() })">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #bulubuliangshuliang="scope">
        <span @click="yt.showEditDialog('buliangbulujilu', scope.row, 'w2', beforeShowEditDialog)" style="color: #419FFF">{{ scope.row.badQuantity }}</span>
      </template>
      <template #shifoubulu="scope">
        <span v-if="scope.row.type == 0">
          {{ $t("fou") }}
        </span>
        <span v-if="scope.row.type == 1">
          {{ $t("shi") }}
        </span>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()" :loading="yt.exportLoading"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!--不良明细-->
      <template v-if="yt.editObj.action == 'buliangbulujilu'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
              <yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('gongxubianma/miaoshu')">
              <el-input disabled v-model="yt.editObj.procedureCodeAndDesc"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('shebeimingcheng')">
              <yi_cross_select disabled multiple :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId"> </yi_cross_select>
            </el-form-item>
          </el-form>
          <template>
            <div style="color: #303133;font-weight: bold">{{ $t("bencibulubuliangpinshu") }}：{{ badAccumulate }}</div>
            <el-tabs v-model="tabsActive">
              <el-tab-pane v-for="(tops, index) in defectTab" :key="tops.levelOneDefectTypeName" :label="tops.levelOneDefectTypeName" :name="tops.levelOneDefectTypeName">
                <div style="display: flex;justify-content: space-between;">
                  <div v-if="tops.defectCodeDTOList.length > 0" style="flex: 1;display:flex;flex-wrap:wrap;justify-content:flex-start;align-items:center;">
                    <div v-for="(items, i) in tops.defectCodeDTOList" :key="i" style="width:50%;">
                      <div style="display: flex;align-items:center;justify-content: space-between;margin-bottom:10px;margin-right: 100px;">
                        <div style="flex: 1;text-align: right;padding-right: 8px;">
                          {{ items.defectDesc }}
                        </div>
                        <div>{{ items.defectCodeBadQuantity }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
const current = year + "-" + month;

const startTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + "01";
const endTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
export default {
  name: "web_production_management_bad_record_list",

  data() {
    return {
      list: [],
      defectTab: [],
      tabsActive: "",
      defectCodeDTOListName: [],
      equipmentId: null,
      // procedureName: null,
      columns: [
        {
          label: "bulushijian",
          prop: "createTime",
          type: "time",
          width: 130,
        },
        {
          label: "bulucaozuoren",
          prop: "createByObject.nickname",
          width: 130,
        },
        {
          label: "shengchangongdanhao",
          prop: "productionNo",
          width: 130,
        },
        {
          label: "ERPgongdanhao",
          prop: "erpNo",
          width: 130,
        },
        {
          label: "shebeimingcheng",
          prop: "equipmentName",
          width: 130,
        },
        {
          label: "mujubianhao",
          prop: "mouldNo",
          width: 130,
        },
        {
          label: "mujumingcheng",
          prop: "mouldName",
          width: 130,
        },
        {
          label: "chanpinbianma",
          prop: "materialCode",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "materialName",
          width: 130,
        },
        {
          label: "gongxugongdan",
          prop: "procedureNo",
        },
        {
          label: "gongxumiaoshu",
          prop: "procedureDesc",
          width: 130,
        },

        {
          label: "bulubuliangshuliang",
          type: "slot",
          prop: "badQuantity",
          width: 130,
        },

        // {
        // 	label: 'buliangshuliang',
        // 	prop: 'badQuantity',
        // 	width: 130,
        // },

        {
          label: "baogongriqi",
          prop: "reportDate",
          type: "time",
          width: 180,
          format: "YYYY-MM-DD",
        },
        {
          label: "baogongbanci",
          prop: "shiftName",
          width: 130,
        },
      ],
    };
  },
  watch: {
    "yt.editObj.action": {
      handler(n) {
        if ((n = "buliangbulujilu")) {
          this.getBadQuantityRecordItem();
        }
      },
      immediate: false,
      deep: true,
    },
  },
  computed: {
    badAccumulate() {
      let total = 0;
      if (this.defectTab.length > 0) {
        for (let i = 0; i < this.defectTab.length; i++) {
          let all = this.defectTab[i]["defectCodeDTOList"];
          if (all.length > 0) {
            for (let j = 0; j < all.length; j++) {
              if (all[j].defectCodeBadQuantity !== null && all[j].defectCodeBadQuantity !== undefined) {
                total += all[j].defectCodeBadQuantity;
              }
            }
          }
        }
      }
      return total;
    },
  },
  created() {
    setTimeout(() => {
      this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, "createTimeStart", this.begin());
      this.$set(this.yt.conditions, "createTimeEnd", this.end());
      // this.yt.list = []
    }, 300);
  },
  methods: {
    //不良明细
    getBadQuantityRecordItem() {
      if (this.yt.editObj.id) {
        this.http
          .get("/web/wo/bad/quantity/report/item/getBadQuantityRecordItem", {
            params: {
              badRecordId: this.yt.editObj.id,
            },
          })
          .then((res) => {
            this.defectTab = res.data || [];
            this.defectTab.forEach((val, index, val_arr) => {
              if (val_arr[index].defectCodeDTOList.length != 0 && val_arr[index].defectCodeDTOList != []) {
                val_arr[index].defectCodeDTOList.forEach((el, i, el_arr) => {
                  this.defectCodeDTOListName = el_arr;
                });
              }
            });
            if (!this.defectTab.length == "") {
              this.tabsActive = this.defectTab[0]["levelOneDefectTypeName"];
            }
          });
      }
    },
    beforeShowEditDialog(editObj) {
      console.log("editObjeditObj", editObj);
      this.equipmentId = editObj.equipmentId;
      // this.procedureName = editObj.procedureCode + ' / ' + editObj.procedureDesc
      return editObj;
    },
    beforeGet(params) {
      params["createTimeStart"] = this.begin();
      params["createTimeEnd"] = this.end();
      return params;
    },
    exportExcel() {
      this.yt.exportLoading = true;
      let params = this.yt.conditions;
      return this.http
        .get("/web/report/export/wo_bad_quantity_record_export", {
          params,
        })
        .then((res) => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.yt.exportLoading = false;
        });
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + "01" + " 00:00:00").getTime();
      console.log("begin", begin);
      return begin;
    },
    end() {
      const date = new Date();
      const end = date.getTime();
      return end;
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = "Y-m-d h:i:s";
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds,
      };
      return format.replace(/\w/g, (o) => {
        return hash[o];
      });
    },
  },
};
</script>
